<template>
  <div class="tab_block">
    <div
      v-if="!oneRow"
      class="tab_block__header"
      :style="{ backgroundColor: (compNo=='BTLH'?'#4a8ae8':'rgba(0, 0, 0, 0.5)')}"
    >
      <div 
        class="tab_block__left"
        :class="{'tab_active': tabIndex === 0, 'throw-row': throwRow }"
        @click="$emit('on-tabLeft-click')"
      >
        <slot name="tab_left" />
      </div>

      <div
        v-show="!throwRow && !oneRow && tabIndex === 0"
        class="left_trape"
      />

      <div
        v-show="!throwRow && !oneRow && tabIndex === 1"
        class="right_trape"
      />

      <div
        v-if="throwRow"
        class="tab_block__center"
        :class="{'tab_active': tabIndex === 1 }"
        @click="$emit('on-tabCenter-click')"
      >
        <slot name="tab_center" />
      </div>

      <div
        v-if="!oneRow"
        class="tab_block__right"
        :class="{'tab_active': tabIndex === tabRightBind, 'throw-row': throwRow }"
        @click="$emit('on-tabRight-click')"
      >
        <slot name="tab_right" />
      </div>
    </div>

    <div class="tab_block__content">
      <slot />
    </div>
  </div>
</template>

<script>
import {localget} from 'Utils/storage'

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      oneRow: false,
      throwRow: false,
      tabRightBind: 1,
      compNo: ''
    }
  },
  created () {
    if (this.$slots['tab_center']) {
      this.throwRow = true
      this.tabRightBind = 2
    }

    if (!this.$slots['tab_right']) {
      this.oneRow = true
    }
  },
  mounted () {
    let state = localget('VUEX_STATE') || {}
    if (state.app && state.app.loginConfig) {
      this.compNo = state.app.loginConfig.by4
    }
  }
}
</script>

<style lang="less">
.tab_block {
  margin:0 12px;
  border-radius: 0.1rem;
  overflow: auto;

  .tab_block__header {
    position: relative;
    z-index: 1;
    height: 0.99rem;
    line-height: 1rem;
    font-size: @font-size-16;
    color: @color-text-white;

    .tab_block__left {
      position: relative;
      float: left;
      z-index: 2;
      width: 45.8333333%;
      height: 1rem;
      text-align: center;
      padding-left: 0.2rem;
    }

    .tab_active {
      font-family: @font-bold-lg;
      border-radius: 0.1rem 0.1rem 0 0;
      background-color: @color-background-white;
      color: @color-text-black;
    }

    .tab_block__right {
      position: relative;
      float: right;
      z-index: 2;
      width: 47.8333333%;
      height: 1rem;
      text-align: center;
      padding-right: 0.2rem;
    }

    .tab_block__center {
      float: left;
      width: 33.3333333%;
      height: 1rem;
      text-align: center;
    }

    .tab_block__left.throw-row, .tab_block__right.throw-row {
      width:33.333333%;
      padding: 0;
    }

    .left_trape {
      position: absolute;
      z-index: -1;
        left: 2.9rem;
        top: -0.25rem;
      width: 0.5rem;
      height: 1.1rem;
      background-color: @color-background-white;
      border-radius: 12px 12px 0 0;
      transform: perspective(0.76rem) rotateX(39deg);
      -webkit-transform: perspective(0.76rem) rotateX(39deg);
      -moz-transform: perspective(0.76rem) rotateX(39deg);
      -ms-transform: perspective(0.76rem) rotateX(39deg);
      -o-transform: perspective(0.76rem) rotateX(39deg);
    }

    .right_trape {
      position: absolute;
      z-index: -1;
      left: 3.51rem;
      top: -0.25rem;
      width: 0.5rem;
      height: 1.1rem;
      background-color: @color-background-white;
      border-radius: 12px 12px 0 0;
      transform: perspective(0.76rem) rotateX(39deg);
      -webkit-transform: perspective(0.76rem) rotateX(39deg);
      -moz-transform: perspective(0.76rem) rotateX(39deg);
      -ms-transform: perspective(0.76rem) rotateX(39deg);
      -o-transform: perspective(0.76rem) rotateX(39deg);
    }
  }

  .tab_block__content {
    box-shadow: 0px -2px 19px 0px rgba(0, 0, 0, 0.09);
    background-color: @color-background-white;
  }
}
</style>
